<template>
  <div class="fc-confirm">
    <div class="fc-confirm__container">
      <h1 class="fc-confirm__title">
        {{ title }}
        <button @click="close" class="btn-close"></button>
      </h1>
      <div class="fc-confirm__content" v-html="subtitle"></div>
      <div class="fc-confirm__button" v-if="buttonText">
        <button class="btn-text" @click="cancel" v-if="cancelButtonText">{{ cancelButtonText }}</button>
        <button class="btn-confirm" @click="confirm">{{ buttonText }}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'confirm',
  props: {
    title: String,
    subtitle: String,
    buttonText: String,
    cancelButtonText: String,
  },
  methods: {
    close() {
      this.$emit('close');
    },
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      this.close();
      this.$emit('callback');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@fastcampus/styles/style.scss';
.btn-close {
  width: 2rem;
  height: 2rem;

  background: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='2.21973' y='3.63416' width='2' height='20' rx='1' transform='rotate(-45 2.21973 3.63416)' fill='%23AAAAAF'/%3E%3Crect x='16.3618' y='2.21997' width='2' height='20' rx='1' transform='rotate(45 16.3618 2.21997)' fill='%23AAAAAF'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  &:hover {
    background: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='2.21997' y='3.63428' width='2' height='20' rx='1' transform='rotate(-45 2.21997 3.63428)' fill='black'/%3E%3Crect x='16.3621' y='2.21997' width='2' height='20' rx='1' transform='rotate(45 16.3621 2.21997)' fill='black'/%3E%3C/svg%3E%0A");
  }
}
.fc-confirm {
  max-width: 39.2rem;
  margin: 0 2rem;

  &__container {
    padding: 2.4rem;
    border-radius: 0.4rem;

    background-color: #fff;
  }
  &__content {
    font-size: 1.4rem;
  }
  &__title {
    display: flex;

    font-size: 1.6rem;
    & + .fc-confirm__content {
      margin-top: 1.6rem;
    }
    .btn-close {
      margin-left: auto;
    }
  }

  &__button {
    display: flex;
    justify-content: flex-end;

    button:first-child:nth-last-child(2),
    button:first-child:nth-last-child(2) ~ button {
      width: auto;
    }
  }

  @include mq($from: large) {
    min-width: 28rem;
  }

  @include mq($until: large) {
    width: 100%;
  }
}
</style>
